import {useEffect, useState} from "react";
import {Popover, PopoverContent, PopoverTrigger} from "../../shadCn/components/ui/popover";
import {Button} from "../../shadCn/components/ui/button";
import {Command, CommandEmpty, CommandGroup, CommandInput, CommandItem} from "../../shadCn/components/ui/command";
import {CommandList} from "cmdk";
import {Check} from "lucide-react";
import {cn} from "../../shadCn/lib/utils";
import {selectProgressStatus} from "../../api/progressStatus/progressStatusService";
import {Label} from "../drawer/drawer/Style"
import {ContentCategory} from "../../constant/CodeSpecNum";
import {getRentalTypes} from "../../api/lifecycle/rental/rentalRequestService";

function SearchProgressComboBox({title = "진행단계", target, value, tableName, search, onChange}){
    const [open, setOpen] = useState(false)
    const [data, setData] = useState(value?.[target] ?? undefined)
    const [progress, setProgress] = useState([]);

    useEffect(() => {
        setData(value?.[target]);
    },[value, target])

    useEffect(() => {
        handleSetData();
    }, [tableName])

    const handleSetData = () => {
        if (tableName !== ContentCategory.RENTAL_ASSET) {
            selectProgressStatus(tableName).then((each) => {
                const transformedData = each.data.map(item => ({
                    id: item.numericValue,
                    name: item.korValue,
                }));
                setProgress([...transformedData])
            })
        } else {
            getRentalTypes((data) => {
                const transformedData = data.map(rentalType => ({
                    id: rentalType.type,
                    name: rentalType.kor
                }));
                setProgress([...transformedData])
            })
        }
    }

    const inputStyle = {
        outline:'none'
    };

    const handler = (target, selected) => {
        setData(data == selected ? null : selected);
        onChange(selected);

        setOpen(false)
    }

    if(progress) {
        return (
            <div className={`mr-2 block`}>
                <Label> {title}</Label>

                <Popover open={open} onOpenChange={setOpen}>
                    <PopoverTrigger asChild style={inputStyle} className={"combobox-hover"}>
                        <Button
                            variant="outline"
                            role="combobox"
                            aria-expanded={open}
                            style={{cursor: "pointer", border: "1px solid #d0d0d0", lineHeight: "30px", padding: "0 15px", height: "30px", marginRight: "5px", background: "white"}}
                        >
                            {data != undefined ? progress.find((option) => option.id === data)?.name : "선택"}
                        </Button>
                    </PopoverTrigger>


                    <PopoverContent className={"w-[200px] p-0 ignore-click"} align={"start"}>
                        <Command>
                            {search &&
                                <>
                                    <CommandInput placeholder="검색" />
                                    <CommandEmpty>검색결과 없음</CommandEmpty>
                                </>
                            }
                            <CommandGroup>

                                <CommandList className="max-h-[10rem] overflow-y-auto w-full">
                                    {progress.map((option) => (
                                        <CommandItem
                                            key={option.id}
                                            value={option.id}
                                            onSelect={() => handler(target, option.id)}
                                            className={"text-[12px]"}
                                        >
                                            <Check
                                                className={cn(
                                                    "mr-2 h-4 w-4",
                                                    data === option.id ? "opacity-100" : "opacity-0"
                                                )}
                                            />
                                            {option.name}
                                        </CommandItem>
                                    ))}
                                </CommandList>
                            </CommandGroup>
                        </Command>
                    </PopoverContent>
                </Popover>
            </div>
        )
    }
}

export {SearchProgressComboBox}